import React from 'react';
import PropTypes from 'prop-types';
import { Input, Icon } from 'antd';

import c from './FilterInput.less';

const iconStyle = { color: 'rgba(0,0,0,.25)' };

function FilterInput({
  onSearch, onFocus, onBlur, placeholder, value, showClear, onClear,
}) {
  let suffix;
  if (showClear) {
    suffix = <Icon type="close-circle" onClick={onClear} style={iconStyle} />;
  } else {
    suffix = <Icon type="search" style={iconStyle} />;
  }

  return (
    <Input
      className={c.quickSearch}
      placeholder={placeholder}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={(event) => onSearch(event.target.value)}
      suffix={suffix}
    />
  );
}

FilterInput.propTypes = {
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClear: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  showClear: PropTypes.bool,
};

FilterInput.defaultProps = {
  placeholder: 'Quick Search',
  onBlur: () => null,
  onFocus: () => null,
  onClear: () => null,
  showClear: false,
  value: '',
};

export default FilterInput;
